import { FC, useCallback, useState } from "react"
import styled from "styled-components"
import { SectionTransparent } from "../ui/SectionTransparent"
import { Button } from "../ui/Button"
import { LicenseForm } from "./LicenseForm"


import { PurchaseFlow } from "./PurchaseFlow"

import { PurchaseType } from "./PurchaseContainer"
import { logoutUser } from '../store/auth';
import { useNavigate } from 'react-router-dom';

const SectionContainerTransparent = styled(SectionTransparent)`
  max-width: 800px;
  text-align: center;
  font-size: 1.3rem;
  gap: 16px;
  width: 100%;
  margin-bottom: 20px;
`

const ButtonWrapper = styled.div`
  flex-direction: column;
  display: flex;
  gap: 0;
`

const ButtonDivider = styled.div`
  font-size: 12px;
  font-weight: bold;
  margin: 16px 0;
  color: #fff;
  position: relative;

  .text {
    display: inline-block;
    padding: 1px 10px;
    color: #000;
    background: #fff;
    position: relative;
    z-index: 10;
    border-radius: 5px;
    text-transform: uppercase;
  }

  &:before {
    content: "";
    display: inline-block;
    position: absolute;
    top: 50%;
    margin-top: -1px;
    left: 0;
    width: 100%;
    height: 1px;
    background-color: #ccc;
  }
`

export const ActivateFlow: FC<{ onAccessGranted: () => void, purchaseType: PurchaseType, onCancel?: () => void }> = ({ onAccessGranted, purchaseType, onCancel }) => {
  const [activationStep, setActivationStep] = useState<'init' | 'license' | 'purchase'>('init')
  const defaultTitle = purchaseType === 'new' ? "Get access to the app!" : "Upgrade your access!"
  const [sectionTitle, setSectionTitle] = useState<string>(defaultTitle)
  const navigate = useNavigate()

  const onLogout = useCallback(() => {
    logoutUser(() => {
      navigate('/auth')
    })
  }, [])

  return (
    <SectionContainerTransparent title={sectionTitle}>
      {activationStep === 'init' && (
        <>
          <h2>Choose your {purchaseType === 'new' ? 'access' : 'upgrade'} method</h2>
          <ButtonWrapper>
            <Button large={true} onClick={() => {
              setActivationStep('purchase')
              setSectionTitle("Select package to purchase")
            }}>Buy access</Button>
            <ButtonDivider><span className={'text'}>or</span></ButtonDivider>
            <Button large={true} onClick={() => {
              setActivationStep('license')
              setSectionTitle("Activate with a License Key")
            }}>Enter License Key</Button>
          </ButtonWrapper>
          { purchaseType === 'upgrade' ? (
            <div>
              <Button tertiary={true} large={true} onClick={() => {
                onCancel?.()
              }}>Cancel</Button>
            </div>
          ) : (
            <div style={{ marginTop: '10px', paddingTop: '20px', borderTop: '1px solid rgba(255,255,255,0.2)' }}>
              <Button tertiary={true} large={true} onClick={() => {
                onLogout?.()
              }}>Logout</Button>
            </div>
          )}
        </>
      )}

      {activationStep === 'license' && (
        <>
          <LicenseForm
            onCancel={() => {
              setActivationStep('init')
              setSectionTitle(defaultTitle)
            }}
            onSuccess={() => {
              setSectionTitle("Access Activated Successfully!")
            }}
            onAccessGranted={onAccessGranted}
          />
        </>
      )}

      {activationStep === 'purchase' && (
        <>
          <PurchaseFlow purchaseType={purchaseType} onStepChanged={(step) => {
            if (step === 'checkout') {
              setSectionTitle("Checkout")
            }
          }}
                        onCancel={() => {
                          setActivationStep('init')
                          setSectionTitle(defaultTitle)
                        }}
          />
        </>
      )}
    </SectionContainerTransparent>
  )
}